import { $addClass, $qs, $removeClass } from 'fxdom/es';
import { MembershipUtilS } from '../../../../../../services/MarppleShop/features/Membership/outbound/share.ts';
import { CategoryServiceS } from '../../../../../../shared/mps-shared/service/category-share.service.ts';
import { GoodsTypeConstantS } from '../../../../../GoodsType/S/Constant/module/GoodsTypeConstantS.js';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { MShopAppProductS } from '../../../../App/Product/S/Function/module/MShopAppProductS.js';
import { MShopUtilF } from '../../../../Util/F/Function/module/MShopUtilF.js';
import { MShopStudioPbProductCreatorMuiF } from '../Mui/module/MShopStudioPbProductCreatorMuiF.js';
import { checkBaseInfo, setEditorAction } from './fn.js';
import { migrateEditorData } from '@modules/MShop/Studio/PbProductCreator/F/Function/openWidgets.ts';
import { GOODS_TYPE } from '@services/MarppleShop/features/Product/type/index.ts';
import { CREW_DOMAIN_NAME } from '@modules/Creator/Crew/S/constant.js';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';

export const openCreator222 = async ({ store_id }) => {
  const base_info = await checkBaseInfo(store_id);
  if (!base_info) {
    return;
  }
  const is_mobile = MShopUtilF.isMobile();
  if (is_mobile) {
    $addClass('open-editor', $qs('html'));
  }
  const {
    product_types,
    store_ecommerce_info,
    stores_delivery_companies,
    all_memberships,
    mps_category_infos,
  } = base_info;
  return MuiF.openFrame(MShopStudioPbProductCreatorMuiF.frame, async (f, p, [t]) => {
    box.set('product_types', product_types);
    box.set('mps_category_infos', mps_category_infos);
    f.is_modal = !MShopUtilF.isMobile();
    t.makeData = () => ({
      product_types,
      store_ecommerce_info,
      stores_delivery_companies,
      crew_domain_name: box.sel('crew_domain_name'),
      store_url: box.sel('store_url'),
      action: setEditorAction(),
      goods_type_id: GoodsTypeConstantS.PBG.id,
      is_studio_worker_admin: !!box.sel('is_studio_worker_admin'),

      /**
       * 멤버십 데이터
       * @type {object[] | null}
       */
      products_memberships: all_memberships
        ? MembershipUtilS.attachSelectedFlagToProductsMemberships({
            all_memberships,
            linked_memberships: [],
          })
        : null,
      is_mobile: MShopUtilF.isMobile(),
      mps_category_infos,
    });
    f.closed = () => {
      if (is_mobile) $removeClass('open-editor', $qs('html'));
    };
    f.hiding = async (el, val) => {
      box.set('im_pb_stores_product', null);
      box.set('pb_stores_product', null);
      box.set('pb_product_spo_options', null);
      box.set('pb_thumbnail_files', []);
      box.set('pb_thumbnail_photos', []);
      if (!MShopUtilF.isMobile()) MShopUtilF.bodyFixed$(false);
      if (val) {
        window.location.reload();
      }
    };
  });
};

export const openCreator = async ({ store_id, creatorProductEditorModal }) => {
  const base_info = await checkBaseInfo(store_id);
  if (!base_info) {
    return;
  }

  const is_mobile = MShopUtilF.isMobile();
  if (is_mobile) {
    $addClass('open-editor', $qs('html'));
  }
  const {
    product_types,
    store_ecommerce_info,
    stores_delivery_companies,
    all_memberships,
    mps_category_infos,
  } = base_info;
  const data = {
    cate_lists: MShopAppProductS.rejectDigitalGoods(true)(box.sel('cate_lists')),
    product_types,
    store_ecommerce_info,
    stores_delivery_companies,
    crew_domain_name: box.sel('crew_domain_name'),
    store_url: box.sel('store_url'),
    action: setEditorAction(),
    goods_type_id: GOODS_TYPE.PBG,
    is_studio_worker_admin: !!box.sel('is_studio_worker_admin'),
    stores_product: {
      store_id,
    },
    is_plus: box.sel('crew_domain_name') !== CREW_DOMAIN_NAME.MARPPLE,
    is_created_sku: false,

    /**
     * 멤버십 데이터
     * @type {object[] | null}
     */
    products_memberships: all_memberships
      ? MembershipUtilS.attachSelectedFlagToProductsMemberships({
          all_memberships,
          linked_memberships: [],
        })
      : null,
    is_mobile: MShopUtilF.isMobile(),

    /**
     * CreatorProductEditorModal NEW 모드
     */
    mode: MODE.NEW,

    mpsCategories: mps_category_infos.map((category) => CategoryServiceS.createMpsCategoryAccessor(category)),
  };

  creatorProductEditorModal.open(migrateEditorData(data));
};
